// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@awc/XDL/types";
import { color, styledScrollbar } from "@awc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import OverflowMenuPresentationPropsDefault from "@insite/mobius/OverflowMenu/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...OverflowMenuPresentationPropsDefault,
        mergeCss: true,
        buttonProps: {
            color: "common.background",
            shape: "pill",
            buttonType: "solid",
            shadow: false,
            css: css`
                && {
                    width: 33px;
                    height: 33px;
                }
                & > ${IconWrapper} {
                    top: 0;
                    color: ${color("text.main")};
                }
                &:hover > ${IconWrapper}, &:focus > ${IconWrapper} {
                    color: ${color("common.white")};
                }
            `,
        },
        cssOverrides: {
            wrapper: css`
                display: flex;
                align-items: center;
            `,
            menu: css`
                overflow-y: auto;
                ${styledScrollbar(4)}
                transition: none;
            `,
            /* to override safari (color:-apple-system-blue) browser native css on all buttons */
            menuItem: css`
                color: ${color("text.main")};
                &:disabled {
                    color: ${color("text.main", 0.3)};
                }
            `,
        },
    },
} as xBaseTheme["overflowMenu"];
